<div class="d-flex flex-column mx-auto align-items-center p-fluid" style="max-width: 1024px;">
  <div class="mb-3">
    <img src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Focus-With-Cloud-New-Trans.png"
      style="width: 400px; height: auto;" />
  </div>

  <div class="alert alert-secondary mb-5" *ngIf="process">
    {{process}}
  </div>

  <form #f="ngForm" class="w-100 d-flex flex-column">
    <ng-container *ngIf="step === 0">
      <div class="w-50 d-flex flex-column mx-auto">
        <div class="mb-3">
          <span class="p-float-label">
            <input type="text" pInputText required name="key" [(ngModel)]="key" />
            <label>Key Number</label>
          </span>
        </div>
        <button type="button" class="btn btn-primary w-100" [disabled]="f.invalid" (click)="findKey()"
          [ladda]="loading">Continue</button>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 1">
      <div class="row mb-3">
        <div class="col-8">
          <input type="text" pInputText placeholder="{{store.name}} - Enter Display Name" required name="name"
            [(ngModel)]="ooVenue.name" />
        </div>
        <div class="col-4">
          <input type="phone" pInputText placeholder="Phone Number" required name="phone" [(ngModel)]="ooVenue.phone" />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-8">
          <input type="email" pInputText placeholder="Contact Person Email Address" required name="email"
            [(ngModel)]="ooVenue.email" email />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-8">
          <input type="text" placeholder="Street Address" pInputText required name="address1"
            [(ngModel)]="ooVenue.address1" />
        </div>
        <div class="col-4">
          <input type="text" placeholder="Suite #" pInputText name="address2" [(ngModel)]="ooVenue.address2" />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-4">
          <input type="text" placeholder="City" pInputText required name="city" [(ngModel)]="ooVenue.city" />
        </div>
        <div class="col-4">
          <p-dropdown autocomplete="address-level1" required name="state" placeholder="State"
            [(ngModel)]="ooVenue.state" [options]="app.references.states" [autoDisplayFirst]="false">
          </p-dropdown>
        </div>
        <div class="col-4">
          <input type="text" placeholder="Zipcode" pInputText required name="zip" [(ngModel)]="ooVenue.zip" />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-4">
          <p-dropdown required name="timezone" placeholder="Timezone" [(ngModel)]="ooVenue.timezone" [options]="timezones"
          [autoDisplayFirst]="false" [filter]="true">
        </p-dropdown>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-4">
          <p-dropdown required name="ccProcessor" placeholder="Select CC Processor" [(ngModel)]="ooVenue.ccProcessor"
            [options]="[
            { label: 'Shift4', value: 1 },
            { label: 'Auth.net', value: 0 }
          ]">
          </p-dropdown>
        </div>
        <div class="col-8">
          <input type="text" placeholder="Processor Authorization Token" pInputText required name="ccProcessorApiKey"
            [(ngModel)]="ooVenue.ccProcessorApiKey" />
        </div>
      </div>

      <div class="row mb-3 align-items-center">
        <div class="col-8">
          Enter the standard tax rate for the store.
        </div>
        <div class="col-4">
          <input type="number" placeholder="Tax Rate" pInputText required name="taxRate"
            [(ngModel)]="ooVenue.taxRate" />
        </div>
      </div>

      <div class="row mb-3 align-items-center">
        <div class="col-8">
          Select the default Revenue Center Number that will be used for Online Ordering Transactions
        </div>
        <div class="col-4">
          <p-dropdown required name="revenueCenter" placeholder="RC #" [(ngModel)]="ooVenue.revenueCenter"
            [options]="revenueCenters">
          </p-dropdown>
        </div>
      </div>

      <div class="row mb-3 align-items-center">
        <div class="col-8">
          Enter an admin password for FocusOnline's Admin Section
        </div>
        <div class="col-4">
          <input type="password" placeholder="Admin Password" pPassword required name="adminPassword"
            [(ngModel)]="ooVenue.adminPassword" />
        </div>
      </div>

      <div class="row mb-3 align-items-center">
        <div class="col-8 text-danger">
          {{passwordMessage}}
        </div>
        <div class="col-4">
          <input type="password" placeholder="Confirm Password" pInputText required name="confirmPassword"
            [(ngModel)]="confirmPassword" />
        </div>
      </div>

      <button type="button" class="btn btn-danger w-100" [disabled]="f.invalid" (click)="onboard()"
        [ladda]="loading">Onboard</button>
    </ng-container>

    <ng-container *ngIf="step === 3">
      <div>
        The menu for {{ooVenue.name}} is ready to go! Visit the admin portal to setup the menu
      </div>
      <div>
        <a href="https://onlineorder.focuspos.com/{{store.key}}/admin" target="blank">Click here to visit their admin
          page</a>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 4">
      <div>
        The menu for {{ooVenue.name}} hasn't loaded yet. You might need to check your configuration at the store level
      </div>
    </ng-container>

    <ng-container *ngIf="step === 99">
      <div class="d-flex flex-column text-center">
        <div class="mb-3">
          It look's like the FocusOnline Account for {{store.name}} is already set up.
        </div>
        <div>
          <a href="https://onlineorder.focuspos.com/{{store.key}}" target="blank">Click here to visit their page</a>
        </div>
      </div>
    </ng-container>
  </form>
</div>